import axios from "../axios/axios";
import { setPermissions } from "../store/actions/permissionAction";
import { errorDispatcher } from "../helpers";

export const apiGetPermissions = (token) => (dispatch, getState) => {
  axios
    .get("permissions/all", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setPermissions(response.data.permissions));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};
